import { useFormik } from 'formik';

export function useSubscriptionFormik() {
    const formik = useFormik<{
        cause: string;
    }>({
        initialValues: {
            cause: '',
        },
        validateOnMount: true,
        validate: (values) => {
            const errors: { cause?: string } = {};
            if (!values.cause) {
                errors.cause = 'required';
            }
            return errors;
        },
        onSubmit: (values, formikHelpers) => { },
        validateOnChange: true,
    });

    return formik;
}
